import React from "react";


const Address = () => {
  return (
    <>
      <p className="open-sans-font custom-span-contact position-relative text-light">
        <i className="fa fa-map position-absolute"></i>
        <span className="d-block">Ville</span><span>Le Havre</span>
      </p>
      {/* End .custom-span-contact */}

      <p className="open-sans-font custom-span-contact position-relative">
      <a href="mailto:briere.brice@gmail.com">
        <i className="fa fa-envelope-open position-absolute text-light"></i>
        <span className="d-block">Mon email</span>{" "}
       briere.brice@gmail.com</a>
      </p>
      {/* End .custom-span-contact */}

      {/* <p className="open-sans-font custom-span-contact position-relative">
        <i className="fa fa-phone-square position-absolute"></i>
        <span className="d-block">call me</span>{" "}
        <a href="Tel: +216 21 184 010">+216 21 184 010</a>
      </p> */}
      {/* End .custom-span-contact */}
    </>
  );
};

export default Address;
